import React from 'react'
import PropTypes from 'prop-types'

/**
 * Table row component
 */
const TableRow = ({ className = '', children, ...props }) => (
  <tr className={className} {...props}>
    {children}
  </tr>
)

TableRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

TableRow.defaultProps = {
  className: ''
}

export default TableRow
